export const SEED_SET_SERVER_HASHED = 'SEED_SET_SERVER_HASHED';
export const SEED_SET_CLIENT = 'SEED_SET_CLIENT';
export const SEED_SET_NONCE = 'SEED_SET_NONCE';
export const SEED_FETCH = 'SEED_FETCH';
export const SEED_REFRESH_CLIENT = 'SEED_REFRESH_CLIENT';
export const SEED_REFRESH_SERVER = 'SEED_REFRESH_SERVER';
